// extracted by mini-css-extract-plugin
module.exports = {"DocumentSidebar":"styles-module--DocumentSidebar--S5r8r","active":"styles-module--active--JClCI"};